import {BaseTemplateAnimationSetModel} from "../../set-models/base-template-animation-set-model";
import {computed, override, makeObservable} from 'mobx';
import {BaseAnimation} from "../../base-animation";
import {AnimationLogoEventRequestParams} from "../animation-logo-event-request-params";

export class BaseGameTemplateAnimationSetModel extends BaseTemplateAnimationSetModel {
  duration: Number;

  constructor(animation) {
    super(animation);

    makeObservable(this);

    this.duration = 10000;
  }

  get eventLogo(): AnimationLogoEventRequestParams {
    return new AnimationLogoEventRequestParams(this.id, this.isHomeCompetitor);
  }

  @computed get homeCompetitorAnimations(): Array<BaseAnimation> {
    const homeCompetitorAnimations: Array<BaseAnimation> = [this.homeCompetitorLogo, this.homeCompetitorEventLogo, this.homeCompetitorEventCardLogo, this.homeCompetitorName, this.homeCompetitorPlayerName, this.homeCompetitorScore];

    return this.isHomeCompetitor ? homeCompetitorAnimations : [];
  }

  @computed get awayCompetitorAnimations(): Array<BaseAnimation> {
    const awayCompetitorAnimations: Array<BaseAnimation> = [this.awayCompetitorLogo, this.awayCompetitorEventLogo, this.awayCompetitorEventCardLogo, this.awayCompetitorName, this.awayCompetitorPlayerName, this.awayCompetitorScore];

    return this.isAwayCompetitor ? awayCompetitorAnimations : [];
  }

  @computed get generalAnimations(): Array<BaseAnimation> {
    const generalAnimations: Array<BaseAnimation> = [this.container, this.statusText, this.statusEventLogo, this.gameTime, this.statusContainer];

    return generalAnimations;
  }

  @override get animations(): Array<BaseAnimation> {
    const animations: Array<BaseAnimation> = [...this.generalAnimations, ...this.homeCompetitorAnimations, ...this.awayCompetitorAnimations].filter(x => !!x);

    return animations;
  }

  @computed get container(): BaseAnimation {
    return null;
  }

  @computed get statusText(): BaseAnimation {
    return null;
  }

  @computed get statusEventLogo(): BaseAnimation {
    return null;
  }

  @computed get homeCompetitorLogo(): BaseAnimation {
    return null;
  }

  @computed get homeCompetitorEventLogo(): BaseAnimation {
    return null;
  }

  @computed get homeCompetitorEventCardLogo(): BaseAnimation {
    return null;
  }

  @computed get homeCompetitorName(): BaseAnimation {
    return null;
  }

  @computed get homeCompetitorPlayerName(): BaseAnimation {
    return null;
  }

  @computed get homeCompetitorScore(): BaseAnimation {
    return null;
  }

  @computed get awayCompetitorLogo(): BaseAnimation {
    return null;
  }

  @computed get awayCompetitorEventLogo(): BaseAnimation {
    return null;
  }

  @computed get awayCompetitorEventCardLogo(): BaseAnimation {
    return null;
  }

  @computed get awayCompetitorName(): BaseAnimation {
    return null;
  }

  @computed get awayCompetitorPlayerName(): BaseAnimation {
    return null;
  }

  @computed get awayCompetitorScore(): BaseAnimation {
    return null;
  }

  @computed get gameTime(): BaseAnimation {
    return null;
  }

  @computed get statusContainer(): BaseAnimation {
    return null;
  }

  durationByRatio(ratio) {
    return ratio * this.duration;
  }

  get animationText(): String {
    return this.animation.animationText;
  }

  get playerName(): String {
    return this.animation.playerName;
  }

  get isHomeCompetitor(): Boolean {
    return this.animation.isHomeCompetitor;
  }

  get isAwayCompetitor(): Boolean {
    return this.animation.isAwayCompetitor;
  }
}
